var map = {
	"./BCH.svg": "b3c2",
	"./BINANCE_COIN_BSC.svg": "ff8c",
	"./BITCOIN.svg": "fa8e",
	"./BITCOIN_CASH.svg": "4fc7",
	"./BNB.svg": "b21d",
	"./BTC.svg": "2d09",
	"./CELO.svg": "cb71",
	"./DOGE.svg": "f587",
	"./DOGE_COIN.svg": "e14f",
	"./ETH.svg": "61b5",
	"./ETHEREUM.svg": "6665",
	"./LITE_COIN.svg": "131f",
	"./LTC.svg": "c687",
	"./MATIC.svg": "65f1",
	"./RIPPLE.svg": "114c",
	"./STELLAR.svg": "3dc3",
	"./TETHER.svg": "7bdd",
	"./TOMAN.svg": "1739",
	"./TRON.svg": "a960",
	"./TRX.svg": "c34d",
	"./USDT.svg": "e600",
	"./XLM.svg": "2965",
	"./XPR.svg": "ecd0",
	"./XRP.svg": "4929",
	"./geram.svg": "1c41",
	"./gold/geram.svg": "2837",
	"./gold/mesghal.svg": "96e0",
	"./gold/nim.svg": "e7cc",
	"./gold/rob.svg": "6acf",
	"./gold/sectamami.svg": "8d91",
	"./gold/tamam.svg": "c14c",
	"./mesghal.svg": "2b48",
	"./nim.svg": "7761",
	"./rob.svg": "edeb",
	"./sectamami.svg": "d8eb",
	"./tamam.svg": "628e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c866";